/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: None = 0, Last24Hours = 1, ThisWeek = 2, ThisMonth = 3, ThisYear = 4, Last7Days = 5, Last30Days = 6
 */
export enum Routemize_Constants_DateFilterType {
    NONE = 'None',
    LAST24HOURS = 'Last24Hours',
    THIS_WEEK = 'ThisWeek',
    THIS_MONTH = 'ThisMonth',
    THIS_YEAR = 'ThisYear',
    LAST7DAYS = 'Last7Days',
    LAST30DAYS = 'Last30Days',
}
